import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faKey } from '@fortawesome/free-solid-svg-icons';
import { Header, HeaderContent, HeaderTitle, LogoutButton } from './AdminStyles';

interface AdminHeaderProps {
  userName?: string;
  onLogout: () => void;
  onChangePassword: () => void;
}

export function AdminHeader({ userName, onLogout, onChangePassword }: AdminHeaderProps) {
  return (
    <Header>
      <HeaderContent>
        <HeaderTitle>
          <h1>Dashboard Admin</h1>
          <p>Bienvenue, {userName || 'Admin'}</p>
        </HeaderTitle>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <LogoutButton onClick={onChangePassword} style={{ background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
            <FontAwesomeIcon icon={faKey} />
            Changer mot de passe
          </LogoutButton>
          <LogoutButton onClick={onLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            Déconnexion
          </LogoutButton>
        </div>
      </HeaderContent>
    </Header>
  );
}
